module.exports = __webpack_public_path__ + "media/images/icon_user4-834f96209b44b33f48b1b2d3b29130d6.png";